import startCase from 'lodash/startCase'

export default {
  props: {
    options: [Array, Object],
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    name: String,
    vid: String,
    error: String,
    optionValue: String,
    optionLabel: String,
    value: [String, Number, File],
    label: String,
    step: [String, Number],
    rules: Array,
    rows: {
      type: [String, Number],
      required: false,
      default: 5,
    },
    cols: {
      type: [String, Number],
      required: false,
      default: 30,
    },
  },
  data: () => ({
    model: null,
  }),
  watch: {
    model (value) {
      this.$emit('input', value)
    },
    value (value) {
      this.model = value
    },
  },
  computed: {
    isRequired () {
      if (this.rules) {
        return this.rules.indexOf('required') > -1
      }
    },
    getRules () {
      if (this.rules) {
        return this.rules.join('|')
      }
    },
    getName () {
      const name = this.name.replace('_', ' ')

      return startCase(name)
    },
    hasLabel () {
      return this.label
    },
  },
  created () {
    this.model = this.value
  },
}
